import { useRef, useEffect } from "react";

// mui-otp
import { MuiOtpInput } from "mui-one-time-password-input";

export default function CodeInput({ 
  value, 
  onChange, 
  onComplete, 
  isInputCodeBlock
}) {

  const containerRef = useRef(null);
  useEffect(() => {
    if (value === '' && containerRef.current) {
      // Находим все инпуты внутри контейнера и фокусируемся на первом
      const inputs = containerRef.current.querySelectorAll('input');
      if (inputs.length > 0) {
        inputs[0].focus();
        inputs[0].setSelectionRange(0, 0);
      }
    }
  }, [value]);
  // это нам чтобы символ в ячейке не выделялся
  const handleInputFocus = (e) => {
    const input = e.target;
    const len = input.value.length;

    requestAnimationFrame(() => {
      input.setSelectionRange(len, len);
    });
  }

  return (
    <div ref={containerRef}>
      <MuiOtpInput
        length={4}
        value={value}
        onChange={onChange}
        onComplete={onComplete}
        autoFocus
        validateChar={char => /^\d$/.test(char)}
        sx={{
          gap: '0.75rem',
        }}
        TextFieldsProps={{
          disabled: isInputCodeBlock,
          size: 'small',
          type: 'text',
          sx: { 
            '& .MuiInputBase-root': {
              maxWidth: '42px',
              maxHeight: '50px',
              padding: '1rem',
              borderRadius: '8px',
              backgroundColor: 'rgd.backgroundCodeInput',
              
              '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },

              '&.MuiOutlinedInput-root.Mui-focused, &.MuiOutlinedInput-root:hover': {
                boxShadow: 'none',
                border: 'none',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                  boxShadow: 'none',
                },
              }
            },
            '& .MuiInputBase-input': {
              textAlign: 'center',
              fontSize: '0.9rem',
              padding: 0,
            },
          },
          inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
            style: { textAlign: 'center', fontSize: '1rem', fontWeight: '600' },
            onFocus: handleInputFocus
          },
        }}
      />
    </div>
  )
} 